import React from 'react';
import { AlertTriangle, Flame, ShieldCheck, Check, Star, ArrowRight, BookOpen, Clock, Filter, Heart, Plus, Quote, VolumeX, Eye, Landmark, ChevronDown, XCircle, CheckCircle2, Lock } from 'lucide-react';
export const WarningIcon = AlertTriangle;
export const FlameIcon = Flame;
export const ShieldIcon = ShieldCheck;
export const CheckIcon = Check;
export const StarIcon = Star;
export const ArrowRightIcon = ArrowRight;
export const BookIcon = BookOpen;
export const ClockIcon = Clock;
export const FilterIcon = Filter;
export const HeartIcon = Heart;
export const CrossIcon = Plus;
export const QuoteIcon = Quote;
export const SilenceIcon = VolumeX;
export const EyeIcon = Eye;
export const TempleIcon = Landmark;
export const ChevronDownIcon = ChevronDown;
export const PathAIcon = XCircle;
export const PathBIcon = CheckCircle2;
export const LockIcon = Lock;